import { OpaccArticle } from './classes/opacc.class.article.js';
import { OpaccPrice } from './classes/opacc.class.price.js';
import { OpaccStock } from './classes/opacc.class.stock.js';
import { OpaccConnectTypeTabs } from './classes/opacc.class.connecttypetabs.js';

/**
 * Funktionalität im Modul "Article"
 * @module article
 */

export const opaccArticlePlugin = new OpaccArticle();
export const opaccPricePlugin = new OpaccPrice();
export const opaccStockPlugin = new OpaccStock();
export const opaccConnectTypeTabsPlugin = new OpaccConnectTypeTabs();